import React from 'react';

function SvgTarif() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
      <defs>
        <style>{".tarif_svg__cls-1{fill:#6b87b1}"}</style>
      </defs>
      <g id="tarif_svg__Calque_2" data-name="Calque 2">
        <g id="tarif_svg__Calque_33" data-name="Calque 33">
          <path
            className="tarif_svg__cls-1"
            d="M25 2A23 23 0 112 25 23 23 0 0125 2m0-2a25 25 0 1025 25A25 25 0 0025 0z"
          />
          <path
            className="tarif_svg__cls-1"
            d="M10.6 28.92c.08-.49.13-1 .22-1.47a14 14 0 017.74-10.22c.41-.21.84-.38 1.29-.58a3.36 3.36 0 01-.85-3.18 3.31 3.31 0 011.17-1.82 3.42 3.42 0 014.57.29 3.37 3.37 0 012.8-1 3.26 3.26 0 012 .94 3.4 3.4 0 01.9 1.5 3.32 3.32 0 010 1.74 3.52 3.52 0 01-.86 1.54c.41.18.79.33 1.16.51a14 14 0 017.91 10.47 15.44 15.44 0 01.13 4.4 5.77 5.77 0 01-4.37 4.89 6.7 6.7 0 01-1.41.16H16.47A5.82 5.82 0 0110.65 32a.31.31 0 00-.05-.12zm14.13 6.3h8.47a3.89 3.89 0 003.8-3.56 16 16 0 00-.26-4.36 12.23 12.23 0 00-14.25-9.39 12 12 0 00-9.64 9 14.86 14.86 0 00-.36 4.46 4.37 4.37 0 00.15.95 4 4 0 003.93 2.87c2.71.01 5.43.03 8.16.03zm-.92-20.92a1.5 1.5 0 00-1.49-1.51 1.51 1.51 0 00-1.55 1.49 1.52 1.52 0 003 0zm3.4-1.52a1.52 1.52 0 000 3 1.52 1.52 0 000-3z"
          />
          <path
            className="tarif_svg__cls-1"
            d="M21.37 25.78h4.38v.89h-4.38zm0 1.64h4.38v.89h-4.38zm2.23 3.9a2.76 2.76 0 01-1-1.2 4.15 4.15 0 01-.37-1.81v-2.53a4.12 4.12 0 01.34-1.78 2.73 2.73 0 012.59-1.64 3 3 0 011.37.31 2.87 2.87 0 011.06.87 3.23 3.23 0 01.57 1.31h-1.37a2.15 2.15 0 00-.38-.66 1.75 1.75 0 00-.58-.44 1.47 1.47 0 00-.67-.16 1.44 1.44 0 00-.88.28 1.77 1.77 0 00-.58.77 3.05 3.05 0 00-.21 1.17v2.53a3 3 0 00.21 1.16 1.77 1.77 0 00.58.77 1.44 1.44 0 00.88.28 1.75 1.75 0 00.67-.14 1.9 1.9 0 00.57-.4 1.79 1.79 0 00.39-.59h1.37a3 3 0 01-.58 1.24 2.85 2.85 0 01-1 .83 3.3 3.3 0 01-1.37.29 2.81 2.81 0 01-1.61-.46z"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgTarif;
